import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import stringHelper from '../../../../Helpers/stringHelper';
import ErrorMessage from '../../../ErrorMessage';
import FreelancerUserService from '../../../../Services/FreelancerUserService';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';

export default class PrimaryFreelancerUserSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    officeId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  // officeId: one office id (the vendor editor), or a list of them (the vendor search's office filter).
  componentDidUpdate(prevProps) {
    if (`${this.props.officeId}` !== `${prevProps.officeId}`) {
      this.populateListData();
    }
  }

  populateListData() {
    if (OfficeHelper.ToOfficeIdList(this.props.officeId).length === 0) {
      this.setState({ selectValues: [] });
      return;
    }

    FreelancerUserService.GetAgencyList(this.props.officeId)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.data.forEach((freelancer) => {
          optValues.push({
            label: `${freelancer.firstName} ${freelancer.lastName}${stringHelper.toBracket(
              freelancer.freelancerUserId
            )}`,
            value: freelancer.freelancerUserId,
            disabled: false,
          });
        });
        let selected = optValues.find((o) => o.value === parseInt(this.props.value));
        if (!selected) selected = optValues.find((o) => o.value === this.props.value);
        this.setState({
          selectValues: optValues,
        });
        if (!selected && parseInt(this.props.value) !== 0) {
          this.props.onChange(this.props.fieldName, this.props.value);
        }
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('PFUS59');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
